var mod10Validator = require('./mod10Validator');
var gs1Validator = require('./gs1Validator');
module.exports = function isWaybillNumber(value) {
    if(!value || isNaN(value))
        return false;
    if(value.length == 10) 
        return mod10Validator(value);
    if(value.length == 20 && value.substring(0,3) == "401")
        value = value.substring(3);
    if(value.length == 17)
        return gs1Validator(value);
    return false;
}
